export default "__VITE_ASSET__Be9mpI0z__"